import {sum} from 'BenchlingUtil';
import {mean, standardDeviation, standardError} from 'ui-library/charting/statistics/StatUtils';

/**
 * Return a simple count of rows
 */
export function aggregateCount<TRow>(rows: Array<TRow>, column: keyof TRow): number | null {
  return rows.length;
}

/**
 * Calculate the mean of the values at a specified key in an array of objects.
 * If there are too few values to calculate the statistic, null is returned.
 */
export function aggregateMean<TRow>(rows: Array<TRow>, column: keyof TRow): number | null {
  return rows.length > 0 ? mean(rows.map((row) => row[column] as unknown as number)) : null;
}

/**
 * Calculate the standard deviation of the values at a specified key in an array of objects.
 * If there are too few values to calculate the statistic, null is returned.
 */
export function aggregateStandardDeviation<TRow>(rows: Array<TRow>, column: keyof TRow): number | null {
  return rows.length > 1 ? standardDeviation(rows.map((row) => row[column] as unknown as number)) : null;
}

/**
 * Calculate the standard error of the sample mean of the values at a specified key in an array of objects.
 * If there are too few values to calculate the statistic, null is returned.
 */
export function aggregateStandardError<TRow>(rows: Array<TRow>, column: keyof TRow): number | null {
  return rows.length > 1 ? standardError(rows.map((row) => row[column] as unknown as number)) : null;
}

/**
 * Calculate the sum of the values at a specified key in an array of objects.
 */
export function aggregateSum<TRow>(rows: Array<TRow>, column: keyof TRow): number | null {
  return sum(rows.map((row) => row[column] as unknown as number));
}
